import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=c134637e&scoped=true"
import script from "./AdminFooter.vue?vue&type=script&lang=ts"
export * from "./AdminFooter.vue?vue&type=script&lang=ts"
import style0 from "./AdminFooter.vue?vue&type=style&index=0&id=c134637e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134637e",
  null
  
)

export default component.exports